var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVim(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 84,
    viewBox: "0 0 80 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_109)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.9989 5.25006C38.0345 5.25006 36.0689 6.01885 34.6004 7.56065L4.70053 38.9591C1.7637 42.0426 1.76786 47.2031 4.70481 50.2867L34.6047 81.6851C37.5416 84.7687 42.4606 84.7731 45.3975 81.6895L75.2974 50.2912C78.2342 47.2076 78.2342 42.0427 75.2974 38.9591L45.3974 7.56065C43.929 6.01885 41.9633 5.25006 39.9989 5.25006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9989 2.62506C38.0345 2.62506 36.0689 3.39385 34.6004 4.93565L4.70053 36.334C1.7637 39.4176 1.76786 44.5781 4.70481 47.6617L34.6047 79.0601C37.5416 82.1437 42.4606 82.1481 45.3975 79.0645L75.2974 47.6662C78.2342 44.5826 78.2342 39.4177 75.2974 36.3341L45.3974 4.93565C43.929 3.39385 41.9633 2.62506 39.9989 2.62506Z",
    fill: "#159532"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40 2.625C38.0356 2.625 36.068 3.39546 34.5996 4.93726L4.70215 36.3347C2.91942 38.2065 2.23437 40.8392 2.61719 43.3125C2.86284 41.7098 3.54701 40.1726 4.70215 38.9597L34.5996 7.56226C36.068 6.02046 38.0356 5.25 40 5.25C41.9644 5.25 43.9271 6.02046 45.3955 7.56226L75.2979 38.9597C76.453 40.1726 77.1364 41.709 77.3828 43.3125C77.7629 40.8392 77.0795 38.2054 75.2979 36.3347L45.3955 4.93726C43.9271 3.39546 41.9644 2.625 40 2.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 13.1251C9.1725 13.1251 7.5 14.8812 7.5 17.0626C7.5 19.2439 9.1725 21.0001 11.25 21.0001H12.5V65.6251C12.5026 72.6388 20.5778 76.1507 25.3027 71.1929C41.2772 53.8951 58.0129 37.316 73.8477 19.9029C74.5575 19.1873 75 18.1822 75 17.0626C75 14.8812 73.3275 13.1251 71.25 13.1251H53.75C51.6725 13.1251 50 14.8812 50 17.0626C50 18.67 50.9125 20.0435 52.2217 20.6566L27.5 46.6143V21.0001H28.75C30.8275 21.0001 32.5 19.2439 32.5 17.0626C32.5 14.8812 30.8275 13.1251 28.75 13.1251H11.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 10.5C9.1725 10.5 7.5 12.2561 7.5 14.4375C7.5 16.6189 9.1725 18.375 11.25 18.375H12.5V63C12.5026 70.0138 20.5778 73.5256 25.3027 68.5679C41.2772 51.27 58.0129 34.6909 73.8477 17.2778C74.5575 16.5622 75 15.5571 75 14.4375C75 12.2561 73.3275 10.5 71.25 10.5H53.75C51.6725 10.5 50 12.2561 50 14.4375C50 16.0449 50.9125 17.4184 52.2217 18.0315L27.5 43.9893V18.375H28.75C30.8275 18.375 32.5 16.6189 32.5 14.4375C32.5 12.2561 30.8275 10.5 28.75 10.5H11.25Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 10.5C9.1725 10.5 7.5 12.2561 7.5 14.4375C7.5 14.9015 7.59035 15.3373 7.72949 15.75C8.24451 14.2225 9.6144 13.125 11.25 13.125H28.75C30.3856 13.125 31.7555 14.2225 32.2705 15.75C32.4097 15.3373 32.5 14.9015 32.5 14.4375C32.5 12.2561 30.8275 10.5 28.75 10.5H11.25ZM53.75 10.5C51.6725 10.5 50 12.2561 50 14.4375C50 14.9 50.0907 15.3336 50.2295 15.7449C50.7457 14.2198 52.1161 13.125 53.75 13.125H71.25C72.8856 13.125 74.2555 14.2225 74.7705 15.75C74.9097 15.3382 75 14.901 75 14.4375C75 12.2561 73.3275 10.5 71.25 10.5H53.75ZM50.835 19.4875L27.5 43.9893V46.6143L52.2217 20.6565C51.6677 20.397 51.2078 19.9794 50.835 19.4875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 84,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVim);
export default __webpack_public_path__ + "static/media/vim.16d9ebc2667a65e7a7fd20e8b52e8195.svg";
export { ForwardRef as ReactComponent };